import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b0e7633"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-avatar" }
const _hoisted_2 = { class: "user-avatar-name" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {"font-weight":"bold","margin-right":"12px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-item-c" }, "重置下载密码", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-item-c" }, "退出登录", -1))
const _hoisted_8 = [
  _hoisted_7
]

import UpdatePasswordModal from "../UpdatePasswordModal.vue";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import { ref, onMounted, reactive } from "vue";
import { handleChangeUser } from "@/api/login";
import { UserOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {

const updatePasswordModal = ref(null);
const handleLogout = () => {
  store.dispatch("logOut");
};
const showModal = ref(false);
const petName = ref("");
const changeUserId = ref(0);
const userContractList = ref([]);
const userId = ref(0);

onMounted(() => {
  petName.value = localStorage.getItem("PETNAME")
    ? localStorage.getItem("PETNAME")
    : "";
  if (localStorage.getItem("userContractList")) {
    userContractList.value = JSON.parse(
      localStorage.getItem("userContractList")
    );
    userId.value = JSON.parse(localStorage.getItem("contractUserId"));
    userContractList.value.map((item: any) => {
      if (item.userId == userId.value) {
        item.icon = "√";
      }
    });
  }
});
const changePassword = () => {
  if (updatePasswordModal.value) updatePasswordModal.value.showModal();
};

const handleOk = () => {
  handleChangeUser({ userId: changeUserId.value }).then((res: any) => {
    if (res.code == 200) {
      localStorage.setItem(
        "contractUserId",
        JSON.stringify(changeUserId.value)
      );
      let params = {
        token: res.data.token,
        petName: res.data.petName,
      };
      changeUserId.value = 0;
      store.dispatch("login", params);
    }
  }).catch;
};
//切换合同
const selectContract = (id: number) => {
  if (userId.value == id) {
    message.info("不能切换至当前合同");
    return;
  }
  showModal.value = true;
  changeUserId.value = id;
};

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_popover, null, {
        content: _withCtx(() => [
          _createVNode(_component_a_menu, {
            slot: "overlay",
            style: {"border":"none"},
            mode: "vertical"
          }, {
            default: _withCtx(() => [
              (userContractList.value.length > 1)
                ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                    key: "sub1",
                    title: "切换合同"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userContractList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_menu_item, { key: index }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "user-item-c",
                              onClick: ($event: any) => (selectContract(item.userId))
                            }, [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(item.icon), 1),
                              _createTextVNode(_toDisplayString(item.contractName), 1)
                            ], 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_menu_item, { key: "5" }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: changePassword
                  }, _hoisted_6)
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, { key: "6" }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: handleLogout
                  }, _hoisted_8)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              style: {"cursor":"pointer"}
            }, [
              _createVNode(_component_a_image, {
                src: "https://img.onehome.cn/new-hr-portal/5aS05YOP.png",
                height: "32px",
                width: "32px",
                preview: false
              })
            ]),
            _createElementVNode("div", _hoisted_2, _toDisplayString(petName.value), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      open: showModal.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      title: "确认切换",
      bodyStyle: {
      fontSize: '16px',
      height: '60px',
    },
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 确认要切换管理合同吗? ")
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(UpdatePasswordModal, {
      ref_key: "updatePasswordModal",
      ref: updatePasswordModal
    }, null, 512)
  ], 64))
}
}

})